import { bool, object, oneOf, string } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import SlideThumbnail from '../SlideThumbnail'
import TextImageSlide from '../TextImageSlide'

import './styles.scss'

const getalignment = (alignment) => {
  if (!alignment) return null
  return alignment
}

const TextImageSlideThumbnail = ({
  alignment = 'right',
  assetReference,
  backgroundImageURL,
  htmlText,
  layout,
  theme = {},
  withHoverableOverlay,
}) => (
  <SlideThumbnail
    className={kuiperClassNames('text-image-slide-thumbnail')}
    renderHeader={false}
    theme={theme}
  >
    <TextImageSlide
      alignment={getalignment(alignment)}
      assetReference={assetReference}
      backgroundImageURL={backgroundImageURL}
      htmlText={htmlText}
      layout={layout}
      theme={theme}
      thumbnail={true}
      viewOnlyMode={true}
      withHoverableOverlay={withHoverableOverlay}
    />
  </SlideThumbnail>
)

TextImageSlideThumbnail.propTypes = {
  alignment: oneOf(['left', 'right', 'top', 'bottom']),
  assetReference: object,
  backgroundImageURL: string,
  htmlText: string,
  layout: string,
  theme: object,
  withHoverableOverlay: bool,
}

export default TextImageSlideThumbnail
